export default "__VITE_ASSET__BED2ua7T__"